import makeUrl from "./UrlMaker";

function getLang() {
    let state = window.store.getState();

    if (!!state.authReducer && !!state.authReducer.lang) {
        return state.authReducer.lang;
    }

    return "pl";
}

async function get(configUrlKey, endpoint, token) {
    let response = await fetch(makeUrl(configUrlKey, endpoint), {
        method: "GET",
        headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Content-Language": getLang(),
        },
        credentials: "include"
    });

    if (response.status - 200 < 100) {
        let responseBodyAsText = await response.text();

        if (!responseBodyAsText) {
            return null;
        }

        try {
            const bodyAsJson = JSON.parse(responseBodyAsText);
            return bodyAsJson;
        } catch (e) {
            window.log.ERROR(`Parsing_Error: ${e.message}`);
            throw Error(`Parsing_Error: ${e.message}`);
        }
    } else {

        window.log.ERROR(`${endpoint}: ${response.status}`);
        throw new Error(response.status + " " + await response.text());
    }
}

function post(
    configUrlKey,
    endpoint,
    token,
    payload,
    rawResponse = false,
    rawBody = false
) {
    return fetch(makeUrl(configUrlKey, endpoint), {
        method: "POST",
        headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Content-Language": getLang(),
        },
        credentials: "include",
        body: !!rawBody ? payload : JSON.stringify(payload),
    })
        .then(async (response) => {
            if (response.status - 200 < 100) {
                if (!!rawResponse) return response;
                let bodtText = response.text();
                return bodtText;
            } else {
                let response_text = await response.text();
                window.log.ERROR(`${endpoint}: ${response.status}`);
                throw new Error(response.status + " " + response_text);
            }
        })
        .then((response) => {
            if (!response) {
                return null;
            }

            try {
                if (!!rawResponse) return response;
                const responseAsJSON = JSON.parse(response);
                return responseAsJSON;
            } catch (e) {
                window.log.ERROR(`Parsing_Error: ${e.message}`);
                throw Error(`Parsing_Error: ${e.message}`);
            }
        });
}

function put(configUrlKey, endpoint, token, payload) {
    return fetch(makeUrl(configUrlKey, endpoint), {
        method: "PUT",
        headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Content-Language": getLang(),
        },
        credentials: "include",
        body: JSON.stringify(payload),
    })
        .then(async (response) => {
            if (response.status - 200 < 100) {
                let bodtText = response.text();
                return bodtText;
            } else {
                let response_text = await response.text();
                window.log.ERROR(`${endpoint}: ${response.status}`);
                throw new Error(response.status + " " + response_text);
            }
        })
        .then((responseBodyAsText) => {
            if (!responseBodyAsText) {
                return null;
            }

            try {
                const bodyAsJson = JSON.parse(responseBodyAsText);
                return bodyAsJson;
            } catch (e) {
                window.log.ERROR(`Parsing_Error: ${e.message}`);
                throw Error(`Parsing_Error: ${e.message}`);
            }
        });
}

function patch(configUrlKey, endpoint, token, payload) {
    return fetch(makeUrl(configUrlKey, endpoint), {
        method: "PATCH",
        headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Content-Language": getLang(),
        },
        credentials: "include",
        body: !!payload ? JSON.stringify(payload) : undefined,
    })
        .then(async (response) => {
            if (response.status - 200 < 100) {
                let bodtText = response.text();
                return bodtText;
            } else {
                let response_text = await response.text();
                window.log.ERROR(`${endpoint}: ${response.status}`);
                throw new Error(response.status + " " + response_text);
            }
        })
        .then((responseBodyAsText) => {
            if (!responseBodyAsText) {
                return null;
            }

            try {
                const bodyAsJson = JSON.parse(responseBodyAsText);
                return bodyAsJson;
            } catch (e) {
                window.log.ERROR(`Parsing_Error: ${e.message}`);
                throw Error(`Parsing_Error: ${e.message}`);
            }
        });
}

function del(configUrlKey, endpoint, token) {
    return fetch(makeUrl(configUrlKey, endpoint), {
        method: "DELETE",
        headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            "Content-Type": "application/json",
            "Content-Language": getLang(),
        },
        credentials: "include"
    }).then(async (response) => {
        if (response.status - 200 < 100) {
            return;
        } else {
            let response_text = await response.text();
            window.log.ERROR(`${endpoint}: ${response.status}`);
            throw new Error(response.status + " " + response_text);
        }
    });
}

export const Api = {
    get,
    post,
    put,
    patch,
    del,
};
